export function ChatIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path
        d="M17.5 11.25A2.5 2.5 0 0 1 15 13.75H6.875L2.5 17.5V5A2.5 2.5 0 0 1 5 2.5H15A2.5 2.5 0 0 1 17.5 5V11.25Z"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
